/**
 * Returns all error messages
 *
 */
const getURLParam = function (param) {
  if (typeof URLSearchParams !== 'undefined') {
    const params = new URLSearchParams(window.location.search)
    if (params.has(param)) {
      return params.get(param)
    }
  } else {
    // old school
    const url = window.location.href
    let queryString = url ? url.split('?')[1] : window.location.search.slice(1)

    if (queryString) {
      queryString = queryString.split('#')[0]
      const params = queryString.split('&')

      for (var i = 0; i < params.length; i++) {
        const param = params[i].split('=')
        const paramName = param[0].toLowerCase()
        const paramValue = typeof (param[1]) === 'undefined' ? null : param[1]

        if (paramName === param.toLowerCase()) {
          return paramValue
        }
      }
    }
  }

  return null
}

export default {
  methods: {
    getURLParam
  }
}
